export default "__VITE_ASSET__cce88082__"